import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {EventService} from '../services/event.service';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-certificates-archives',
  templateUrl: './certificates-archives.component.html',
  styleUrls: ['./certificates-archives.component.scss']
})
export class CertificatesArchivesComponent implements OnInit {

  public displayedEventColumns: string[] = [ 'name', "date", "staff", "user" ];
  public eventsDataSource: MatTableDataSource<any>

  constructor(
     private _activeRoute: ActivatedRoute,
     private _eventService: EventService
  ) { }

  ngOnInit() {
        this._activeRoute.params.subscribe(params => {
      const isCongress = params[ 'isCongress' ] === 'true';
      this.selectEvents(isCongress)
    })
  }

  async selectEvents(isCongress){

    const events = await this._eventService.loadEventsArchived(isCongress)
    // console.log(JSON.stringify(events));
    this.eventsDataSource = new MatTableDataSource(events)

  }

}
